import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  MapPinIcon, 
  PhoneIcon, 
  EnvelopeIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';

const Footer: React.FC = () => {
    const { t } = useTranslation();
    return (
        <footer className="relative bg-gradient-to-b from-[rgba(31,41,90,0.99)] to-[rgba(20,30,70,0.99)] text-white overflow-hidden z-10 border-t border-white/[0.08]">
            {/* 背景图案 */}
            <div className="absolute inset-0 bg-[url('/images/dot-pattern.svg')] bg-[size:20px] opacity-[0.04] -z-10"></div>
            
            <div className="relative z-5 max-w-7xl mx-auto py-16 px-6">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-[1fr_2fr]">
                    <div className="flex flex-col gap-6">
                        <img
                            className="w-12 h-12 object-contain rounded-full bg-white p-1 shadow-md transition-all duration-300 ease-in-out hover:scale-105"
                            src="/logo.png"
                            alt="Great Lakes Academy"
                        />
                        <p className="text-white/70 text-[0.95rem] leading-relaxed max-w-[35ch]">
                            {t('footer.about.description')}
                        </p>
                    </div>
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-8 w-full">
                        <div className="flex flex-col gap-5 min-w-[250px]">
                            <h3 className="text-white text-base font-semibold relative pb-3 tracking-wider uppercase after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-8 after:h-0.5 after:bg-gradient-to-r after:from-[rgba(113,128,250,0.8)] after:to-[rgba(113,128,250,0.2)] after:rounded-md">
                                {t('footer.links.title')}
                            </h3>
                            <ul className="flex flex-col gap-3">
                                {Object.entries(t('footer.links.items', { returnObjects: true })).map(([key, value]) => (
                                    <li key={key}>
                                        <Link
                                            to={`/${key === 'home' ? '' : key}`}
                                            className="text-white/70 text-[0.95rem] inline-flex items-center gap-2 transition-all duration-200 hover:text-white hover:translate-x-1 relative after:content-[''] after:absolute after:w-0 after:h-px after:bg-white/30 after:bottom-[-2px] after:left-0 after:transition-all after:duration-300 hover:after:w-full"
                                        >
                                            <ChevronRightIcon className="h-3.5 w-3.5" />
                                            {value}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="flex flex-col gap-5 min-w-[250px]">
                            <h3 className="text-white text-base font-semibold relative pb-3 tracking-wider uppercase after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-8 after:h-0.5 after:bg-gradient-to-r after:from-[rgba(113,128,250,0.8)] after:to-[rgba(113,128,250,0.2)] after:rounded-md">
                                {t('footer.contact.title')}
                            </h3>
                            <ul className="flex flex-col gap-3">
                                <li className="flex items-start gap-3 text-white/70 mb-3 text-[0.95rem]">
                                    <MapPinIcon className="h-5 w-5 text-[rgba(113,128,250,0.8)] flex-shrink-0 mt-1" />
                                    <div className="flex flex-col gap-1 text-white/70 text-[0.95rem] leading-tight">
                                        <div>3300 Plymouth Blvd</div>
                                        <div>#46253</div>
                                        <div>Plymouth, MN 55447</div>
                                    </div>
                                </li>
                                <li className="flex items-start gap-3 text-blue-500 underline mb-3 text-[0.95rem] cursor-pointer break-keep">
                                    <EnvelopeIcon className="h-5 w-5 text-[rgba(113,128,250,0.8)] flex-shrink-0 mt-1" />
                                    <a href="mailto:info@great-lakes-academy.org">info@great-lakes-academy.org</a>
                                </li>
                                {/* 电话（学校要求不展示）
                                <li className="flex items-start gap-3 text-white/70 mb-3 text-[0.95rem] cursor-pointer break-keep">
                                    <PhoneIcon className="h-5 w-5 text-[rgba(113,128,250,0.8)] flex-shrink-0 mt-1" />
                                    <a href="tel:+161****2000">（612）405-2758</a>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="relative mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <p className="text-white/60 text-sm">
                        {t('footer.copyright')}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 